<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                            <router-link :to="{'name': 'CadastrarCatalogo'}" class="button block-mobile big float-right hidden-md hidden-lg" v-if="$root.user.tipo == 'admin'">
                                <i class="material-icons">add</i>
                                Cadastrar produto
                            </router-link>
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">

                        <div class="col-lg-12 hidden-xl">
                            <router-link :to="{'name': 'CadastrarCatalogo'}" class="button block-mobile big" v-if="$root.user.tipo == 'admin'">
                                <i class="material-icons">add</i>
                                Cadastrar produto
                            </router-link>
                        </div>
                        <div class="col-lg-9 col-md-9 col-xl-6 col-xs-12 margin-top-20">

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="listings-container compact-list-layout" v-show="data.itens.length > 0">

                                <a class="job-listing" v-for="item in data.itens">
                                    <div class="job-listing-details">

                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">{{item.nome}}</h3>
                                            <div class="job-listing-footer">
                                                <ul>
                                                    <div class="hidden-lg hidden-md hidden-xl hidden-sm">
                                                        <li>
                                                            <strong>R$ {{item.valorFormatado}}</strong>
                                                        </li>
                                                        <br>
                                                    </div>                                                               
                                                </ul>                       
                                            </div>
            
                                            <div class="datahora">
                                                {{item.atualizacao | formatDate}}</li>
                                            </div>
                                        </div>
                                        <ul class="dashboard-task-info hidden-xs">
                                            <li>
                                                <strong>R$ {{item.valorFormatado}}</strong>                                                        
                                                <span>Preço</span>
                                            </li>                   
                                        </ul>
                                    </div>
                                            
                                    <router-link v-if="$root.user.tipo == 'admin'" :to="{'name': 'EditarCatalogo', 'query': {'c': item.cod}}" class="button small gray margin-top-10">
                                        <i class="material-icons">edit</i>
                                        Editar
                                    </router-link>
                                    <a v-if="$root.user.tipo == 'admin'" class="button small red margin-top-10" v-on:click="del(item.cod)">
                                        <i class="material-icons">delete</i>
                                        Apagar
                                    </a>           
                                    <div class=" hidden-xl margin-top-10"></div>                                        
                                </a>


<!--                                 <a class="job-listing">

                                    <div class="job-listing-details">

                                        <div class="job-listing-description">
                                            <h3 class="job-listing-title">JET-A1</h3>
                                            <div class="job-listing-footer">
                                                <ul>
                                                    <div class="hidden-lg hidden-md hidden-xl hidden-sm">
                                                        <li>
                                                            <strong>R$ 8,50</strong>
                                                        </li>
                                                        <br>
                                                    </div>                                                               
                                                </ul>                       
                                            </div>
            
                                            <div class="datahora">
                                                29/06/2020 08:29</li>
                                            </div>
                                        </div>
                                        <ul class="dashboard-task-info hidden-xs">
                                            <li>
                                                <strong>R$ 8,50</strong>                                                        
                                                <span>Preço</span>
                                            </li>                   
                                        </ul>
                                    </div>
                                            
                                    <button class="button small gray margin-top-10">
                                        <i class="material-icons">edit</i>
                                        Editar
                                    </button>
                                    <button class="button small gray margin-top-10" v-on:click.stop.prevent="delItem('7005e847952f1e5d1ec95144cf506ac9')">
                                        <i class="material-icons">delete</i>
                                        Apagar
                                    </button>           
                                    <div class="hidden-lg hidden-md hidden-sm hidden-xl margin-top-10"></div>                                        

                                </a>                                
 -->

                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Catalogo',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    }, 
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },           
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "catalogo"
            }              
        }
    },
    methods: {
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/catalogo.php", {params: self.form, db: "catalogo"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/catalogo.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.get();
            });
        } else {
            self.get();
        }  
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Catalogo.vue